<template>
  <modal :show.sync="show" :on-close="onClose" custom-class="delete-modal">
    <woot-modal-header
      :header-title="title"
      :header-content="message"
      :header-content-value="messageValue"
    />
    <div class="modal-footer delete-item">
      <woot-button variant="clear" class="action-button btn-primary" @click="onClose">
        {{ rejectText }}
      </woot-button>
      <woot-button
        color-scheme="alert"
        class="action-button"
        :is-loading="isLoading"
        variant="smooth"
        @click="onConfirm"
      >
        {{ confirmText }}
      </woot-button>
    </div>
  </modal>
</template>

<script>
import Modal from '../../Modal';

export default {
  components: {
    Modal,
  },
  props: {
    show: Boolean,
    onClose: { type: Function, default: () => {} },
    onConfirm: { type: Function, default: () => {} },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    messageValue: { type: String, default: '' },
    confirmText: { type: String, default: '' },
    rejectText: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
  },
};
</script>
<style lang="scss" scoped>
.action-button {
  max-width: var(--space-giga);
}
</style>

<style lang="scss">
/* Remover height: 100% apenas do modal de confirmação de deleção */
.modal-mask.delete-modal .modal-container,
.modal-mask.delete-item-modal .modal-container {
  height: auto !important;
  max-height: none !important;
  min-height: auto !important;
}
</style>
